import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var rangeLength = 5;
var propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired
};
var defaultProps = {
  currentPage: 1,
  totalPages: 1
};

var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["currentPage", "totalPages", "onChange"]);

  var _useState = useState(currentPage),
      _useState2 = _slicedToArray(_useState, 2),
      currentIndex = _useState2[0],
      setCurrentIndex = _useState2[1];

  useEffect(function () {
    console.log("useEffect::setCurrentIndex(".concat(currentPage, ")"));
    setCurrentIndex(currentPage);
  }, [currentPage]);

  var updateIndex = function updateIndex(newIndex) {
    var updatedIndex = {
      prevIndex: currentIndex,
      index: newIndex
    };
    setCurrentIndex(newIndex);
    onChange && onChange(updatedIndex);
  };

  var handleFirstPageClick = function handleFirstPageClick() {
    updateIndex(1);
  };

  var handlePrevPageClick = function handlePrevPageClick() {
    updateIndex(currentIndex - 1);
  };

  var handleNextPageClick = function handleNextPageClick() {
    updateIndex(currentIndex + 1);
  };

  var handlePageClick = function handlePageClick(page) {
    updateIndex(page);
  };

  var getRange = function getRange(currentPage) {
    var leftBound = 1;
    var rightBound = 1;

    if (totalPages <= rangeLength) {
      rightBound = totalPages;
    } else {
      var leftOffset = Math.max(1, currentPage - Math.floor(rangeLength / 2));
      var rightOffset = Math.min(totalPages, leftOffset + rangeLength - 1);

      if (rightOffset == totalPages && totalPages - rangeLength > 0) {
        leftBound = rightOffset - rangeLength + 1;
      } else {
        leftBound = leftOffset;
      }

      rightBound = rightOffset;
    }

    var length = rightBound - leftBound + 1;
    var returnArray = [];

    var _loop = function _loop(i) {
      var _classNames;

      var pageItem = i + leftBound;
      var pageNumberClasses = classnames((_classNames = {
        pagination__control: true,
        'pagination__control--page': true
      }, _defineProperty(_classNames, "pagination__control--page-".concat(pageItem), true), _defineProperty(_classNames, "selected", pageItem === currentPage), _defineProperty(_classNames, 'd-none', totalPages == 1), _classNames));
      returnArray.push( /*#__PURE__*/React.createElement("button", {
        key: pageItem,
        disabled: pageItem === currentPage,
        title: pageItem === currentPage ? 'You are on page ' + pageItem : 'Go to page ' + pageItem,
        className: pageNumberClasses,
        onClick: function onClick() {
          return handlePageClick(pageItem);
        }
      }, pageItem));
    };

    for (var i = 0; i < length; i++) {
      _loop(i);
    }

    return returnArray;
  };

  var getControlClasses = function getControlClasses(control) {
    var cNames = {
      'btn btn-textonly-primary btn-icon-only btn-sm': true,
      pagination__control: true,
      'd-none': totalPages == 1
    };

    if (control) {
      cNames["pagination__control--".concat(control)] = true;
    }

    return classnames(cNames);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "pagination"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: currentIndex === 1,
    onClick: handleFirstPageClick,
    className: getControlClasses('start'),
    title: "Go to page 1"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon prism-icon-back-to-start"
  })), /*#__PURE__*/React.createElement("button", {
    disabled: currentIndex === 1,
    onClick: handlePrevPageClick,
    className: getControlClasses('prev'),
    title: "Go to previous page"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon prism-icon-arrow-left"
  })), getRange(currentIndex), /*#__PURE__*/React.createElement("button", {
    disabled: currentIndex === totalPages,
    onClick: handleNextPageClick,
    className: getControlClasses('next'),
    title: "Go to next page"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon prism-icon-arrow-right"
  })));
};

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;

export default Pagination;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
